<script lang="ts" setup>
import { RouteName } from "@/router";
import { authService } from "@/services/auth-service";
import { onBeforeMount, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import {
  isCustomerAdminForAtLeastOneCustomer,
  isOneAdmin,
  isOneUser,
  isOneUserAdmin,
} from "@/utils/roles.util";

const router = useRouter();
const message = ref("");
const { t } = useI18n();

async function onLogin() {
  try {
    message.value = "";

    // If not authenticated, attempt login
    if (!authService.authenticated) {
      try {
        await authService.login();
      } catch (loginError) {
        console.error("Login error:", loginError);
        message.value = t("general.loginFailed");
        return;
      }
    }

    const loggedInUser = await authService.loadLoggedInUser();
    if (loggedInUser) {
      if (isOneAdmin(loggedInUser)) {
        await router.push({ name: RouteName.Customers });
        return;
      } else if (isCustomerAdminForAtLeastOneCustomer(loggedInUser)) {
        await router.push({ name: RouteName.Customers });
        return;
      } else if (isOneUser(loggedInUser) || isOneUserAdmin(loggedInUser)) {
        await router.push({ name: RouteName.PhoneService });
        return;
      } else {
        await router.push({ name: RouteName.ServiceOrders });
        return;
      }
    }
  } catch (error: unknown) {
    message.value = t("general.loginFailed");
    console.error(error);
  }
}

onBeforeMount(async () => {
  try {
    // Try to handle any pending redirects
    await authService.handleLoginRedirects();

    // If already authenticated, redirect to customers page
    if (authService.authenticated) {
      await router.push({ name: RouteName.Customers });
    }
  } catch (error) {
    console.error("Error in onBeforeMount:", error);
  }
});
</script>

<template>
  <div class="login-container">
    <section>
      <div class="has-text-centered mb-4 mt-6">
        <img src="@/assets/logo.png" alt="One Nordic" class="logo" />
        <!--p class="is-size-4">{{ t('general.welcomeText') }}</p-->
        <p class="content">
          Välkommen till ONE Nordic ABs kundportal, verktyget som ger dig en
          detaljerad uppföljning av dina ärenden med mera.
        </p>
      </div>

      <button
        class="button is-fullwidth mt-5 microsoft-login-button"
        @click="onLogin"
      >
        <img src="@/assets/logo-ms.png" alt="" />{{
          t("general.loginWithMicrosoft")
        }}
      </button>

      <p v-if="message" class="has-text-danger has-text-centered mt-5">
        {{ message }}
      </p>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.login-container {
  display: grid;
  place-items: center;
  place-content: center;
  height: 100%;
  section {
    width: clamp(315px, 100%, 350px);
  }
}
.logo {
  max-height: 6rem;
}
.microsoft-login-button {
  width: auto;
  color: #333;
  margin: 0 auto;
  img {
    height: 20px;
    margin-right: 12px;
  }
}
</style>
